import React from 'react'
import { Tr, InputNumerText, InputDate, ComboNormal, values, setValues } from '../components'
const EditarAlumno = ({ setValues, values, generos, handleDate }) => {
  return (
    <>
      <Tr
        cols={"5"}
        title="Alumno"
        gap="2"
        dist={[1,2,2,3]}
        children={[
          <InputNumerText /*enabled={usuario}*/  label={"Carnet"} name={"Carnet"} values={values} setValue={setValues} type="text" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
          <InputNumerText enabled={true}  label={"Nombres"} name={"NombreAlumno"} values={values} setValue={setValues} type="text" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
          <InputNumerText enabled={true}  label={"Apellidos"} name={"ApellidoAlumno"} values={values} setValue={setValues} type="text" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
          <ComboNormal    disabled={true} label={"Grado"} name={"Grado"} values={generos} /*setComboValue={setValues}*/ id="id" text="nombre" defaultValue="" fakeValue="" tryToSave="" required={values.Nombre1 ? false : true}/*handleBlur={existeLoginId}*/></ComboNormal>,
          <ComboNormal    disabled={true} label={"Genero"} name={"GeneroAlumno"} values={generos} /*setComboValue={setValues}*/ id="id" text="nombre" defaultValue="" fakeValue="" tryToSave="" required={values.Nombre1 ? false : true}/*handleBlur={existeLoginId}*/></ComboNormal>,
          <InputDate      enabled={true}      title='Fecha de nacimiento' value={values.FechaNac} type="date" handleChange={handleDate}/>,
          ]}
      ></Tr>
    </>
  )
}

export default EditarAlumno